import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sv from '../assets/locales/sv.json';
import dk from '../assets/locales/dk.json';
import no from '../assets/locales/no.json';
import en from '../assets/locales/en.json';
import de from '../assets/locales/de.json';

i18n.use(initReactI18next).init({
  resources: {
    sv: {
      translation: sv
    },
    dk: {
      translation: dk
    },
    no: {
      translation: no
    },
    en: {
      translation: en
    },
    de: {
      translation: de
    }
    // add more languages here
  },
  // lng: 'sv', // set the default language
  fallbackLng: 'en', // fallback to English if a translation is not available
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
